import { Stack, styled, Typography } from '@mui/material';

export const StyledContainer = styled(Stack)(({ theme }) => ({
  marginTop: theme.spacing(2),
  textAlign: 'left',
  gap: theme.spacing(1),
}));

export const StyledAgreementText = styled(Typography)(({ theme }) => ({
  fontSize: 10,
  lineHeight: theme.spacing(2),
  color: theme.palette.grey[500],
}));

export const StyledInstructions = styled(StyledAgreementText)({
  fontWeight: 700,
});
